import React from 'react';
import ErrorMessage from './ErrorMessage'

import '../../styles/messages/ImageMessage.css'


export default class ImageMessage extends React.PureComponent{
	state = {
		src: null
	}

	onImageClick(){
		this.context.messageList.onImageClick(this);
	}

	componentDidMount(){
		const {message} = this.props
		
		if(message.status){
			this.setState({src: this.getThumbnailUrl()})
		}else{
			this.context.classroomPage.lazyLoads.push({
				el: document.getElementById('message_' + message.id),
				onVisible: () => this.setState({src: this.getThumbnailUrl()})
			})
		}
	}

	getSourceUrl(){
		const {message} = this.props
		if(!message.content)
			return message.local_id
		return message.content.replace(/[\/-]picmsg420/, '');
	}

	getThumbnailUrl(){
		const {message} = this.props
		if(!message.content)
			return message.local_id
		const idx = message.content.indexOf('static-cos.lycheer.net')
		if(idx > 0)
			return message.content
		return message.content
	}

	render(){
		try {
            if(!this.state.src){
                return <span className="image-lazyload">
				<i className="iconfont icon-zhaopian"></i>
			</span>
            }
            return (
				<img className="image-content " alt=""
					 src={this.state.src}
					 onClick={this.onImageClick.bind(this)}
				/>
            )
		} catch(e) {
			return <ErrorMessage/>
		}
	}
}


ImageMessage.contextTypes = {
  	messageList: React.PropTypes.object,
  	classroomPage: React.PropTypes.object
};



// WEBPACK FOOTER //
// ./src/components/messages/ImageMessage.js